import React from "react";
// Load Profile Report page

// Default
import { useState } from "react";

// Mui
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

// Custom
import Layout from "../../layout";
import ContainedButton from "../../forms/button/ContainedButton";
import CustomOutlinedSelect from "../../forms/select/OutlinedCustomSelect";
import DatePickerInput from "../../forms/input/DatePickerInput";
import CustomDataTable from "../../components/table/CustomTable";
import LoadProfileDataLineChart from "../charts/LoadProfileDataLineChart";

const data = [
  {
    id: 1,
    blocktiming: "00:00-00:30",
    networkname: "DTR1",
    kwhconsumption: 120,
    kvahconsumption: 130,
    kvarhconsumption: 15,
    demandvalue: 140,
    powerfactor: 0.98,
  },
  {
    id: 2,
    blocktiming: "00:30-01:00",
    networkname: "DTR2",
    kwhconsumption: 150,
    kvahconsumption: 160,
    kvarhconsumption: 20,
    demandvalue: 165,
    powerfactor: 0.97,
  },
];

const LoadProfileReport: React.FC = () => {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  const downloadCSV = () => {
    const headers = Object.keys(data[0]).join(",");
    const rows = data.map((row) => Object.values(row).join(",")).join("\n");
    const csvContent = `${headers}\n${rows}`;

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${window.location.pathname.slice(1)}.csv`;
    link.click();

    URL.revokeObjectURL(link.href);
  };

  const networkOptions = [
    { value: "DTR1", label: "DTR1" },
    { value: "DTR2", label: "DTR2" },
  ];

  const COLUMNS = [
    "Blocking Timing",
    "Network Name",
    "KWH Consumption",
    "KVAH Consumption",
    "KVARH Consumption",
    "Demand value",
    "Power Factor",
  ];

  const rowsContent = data?.map((item, index) => (
    <TableRow
      key={index}
      sx={{
        height: "50px",
        background: (index + 1) % 2 ? "#F9FCFE" : "transparent",
      }}
      className="custom_table_tbody"
    >
      <TableCell>
        <Typography className="custom_table_tbody_cell">
          {item.blocktiming}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography className="custom_table_tbody_cell">
          {item.networkname}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography className="custom_table_tbody_cell">
          {item.kwhconsumption}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography className="custom_table_tbody_cell">
          {item.kvahconsumption}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography className="custom_table_tbody_cell">
          {item.kvarhconsumption}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography className="custom_table_tbody_cell">
          {item.demandvalue}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography className="custom_table_tbody_cell">
          {item.powerfactor}
        </Typography>
      </TableCell>
    </TableRow>
  ));

  return (
    <Layout>
      <Card className="meters_title_card">
        <Typography variant="h5">Load Profile Data Report</Typography>
      </Card>

      <Card sx={{ mt: "20px", maxHeight: "400px" }}>
        <CardHeader
          title={
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Typography variant="h5">Load Profile Data Report</Typography>
              <Stack direction={"row"} gap={"20px"} alignItems={"center"}>
                <CustomOutlinedSelect
                  placeholder={"Select Network"}
                  options={networkOptions}
                  width="fit-content"
                />
                <DatePickerInput
                  placeholder={"dd/mm/yyyy"}
                  width={"fit-content"}
                />
              </Stack>
            </Stack>
          }
        />
        <Divider />

        <CardContent>
          <LoadProfileDataLineChart />
        </CardContent>
      </Card>

      <Card sx={{ mt: "20px" }}>
        <CardHeader
          title={
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Typography variant="h5">Report Details</Typography>
              <ContainedButton
                label={"Download CSV"}
                sx={{
                  width: "fit-content",
                  fontWeight: 600,
                  color: "#ffffff",
                }}
                onClick={downloadCSV}
              />
            </Stack>
          }
        />
        <Divider />

        <CardContent sx={{ overflow: "auto", maxHeight: "600px" }}>
          <CustomDataTable
            sx={{ maxHeight: "600px" }}
            columns={COLUMNS}
            pagination={true}
            rowsContent={rowsContent}
            Actions={true}
            onPageChange={(_, newPage) => setPage(newPage)}
            rowsPerPage={rowsPerPage}
            page={page}
            onRowsPerPageChange={handleChangeRowsPerPage}
            totalCount={data?.length}
          />
        </CardContent>
      </Card>
    </Layout>
  );
};

export default LoadProfileReport;
